module["exports"] = ["دیزل", "الکتریکی", "بنزین", "هیبرید"];